import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button, Col, Form, Input, Label, Row } from "reactstrap"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import API from "../../../api"
import { withTranslation } from "react-i18next"
import { AvForm } from "availity-reactstrap-validation"
import DatePicker from "react-datepicker";
const AddParametrage = props => {
  const [dateOuverture, setDateOuverture] = useState(new Date())
  const [dateFermuture, setDateFermuture] = useState(new Date())
  const [malus, setMalus] = useState("")
  const [bonus, setBonus] = useState("")
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  const save = async () => {
    let convert_ouverture = dateOuverture
    let month_ouverture = "" + (convert_ouverture.getMonth() + 1)
    let day_ouverture = "" + convert_ouverture.getDate()
    let year_ouverture = convert_ouverture.getFullYear()
    if (month_ouverture.length < 2) month_ouverture = "0" + month_ouverture
    if (day_ouverture.length < 2) day_ouverture = "0" + day_ouverture
    let convertDate_ouverture = [
      year_ouverture,
      month_ouverture,
      day_ouverture,
    ].join("-")
    ///date_fermeture
    let convert_fermeture = dateFermuture
    let month_fermeture = "" + (convert_fermeture.getMonth() + 1)
    let day_fermeture = "" + convert_fermeture.getDate()
    let year_fermeture = convert_fermeture.getFullYear()
    if (month_fermeture.length < 2) month_fermeture = "0" + month_fermeture
    if (day_fermeture.length < 2) day_fermeture = "0" + day_fermeture
    let convertDate_fermeture = [
      year_fermeture,
      month_fermeture,
      day_fermeture,
    ].join("-")
    API.post("orientation_config/store", {
      annee_id,
      user_id,
      date_ouverture: convertDate_ouverture,
      date_fermeture: convertDate_fermeture,
      bonus,
      malus,
    }).then(res => {
      toast.success(" 🔓✔️  Paramétrage ajoutée Avec succès", {
        containerId: "A",
      })
      props.setSection(1)
    })
  }
  useEffect(async () => {
    const res = await API.post("orientation_config/get_config", {
      annee_id,
    }).then(res => {
      setDateFermuture(new Date(res.data.OrientationConfig.date_fermeture))
      setDateOuverture(new Date(res.data.OrientationConfig.date_ouverture))
      setBonus(res.data.OrientationConfig.bonus)
      setMalus(res.data.OrientationConfig.malus)
    })
  }, [])
  return (
    <React.Fragment>
      <Row>
        <AvForm>
          <Form>
            <Row>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    {" Date d'ouverture :"}
                  </Label>
                  <Col md={12} className="pr-0">
                    <DatePicker
                      className="form-control ddate"
                      selected={dateOuverture}
                      value={dateOuverture}
                      onChange={e => setDateOuverture(e)}
                      dateFormat="dd/MM/yyyy"
                    />
                  </Col>
                </div>
              </Col>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    {" Date de fermeture :"}
                  </Label>
                  <Col md={12} className="pr-0">
                    <DatePicker
                      className="form-control ddate"
                      selected={dateFermuture}
                      value={dateFermuture}
                      onChange={e => setDateFermuture(e)}
                      dateFormat="dd/MM/yyyy"
                    />
                  </Col>
                </div>
              </Col>
            </Row>

            <Row>
              <Col md="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Bonus session principale :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Malus session contrôle"
                    type="number"
                    value={bonus}
                    onChange={e => setBonus(e.target.value)}
                  />
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    Malus session contrôle :
                  </Label>
                  <Input
                    lg="3"
                    className="form-control"
                    placeholder="Malus de redoublement "
                    type="number"
                    value={malus}
                    onChange={e => setMalus(e.target.value)}
                  />
                </div>
              </Col>
            </Row>
          </Form>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Col lg="6">
              <div
                className="text-center mt-4"
              >
                <button
                  type="button"
                  className="btn btn-primary "
                  onClick={save}
                >
                  {props.t("Confirmer")}
                </button>
              </div>
            </Col>
          </div>
        </AvForm>
      </Row>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}
export default withTranslation()(AddParametrage)
AddParametrage.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}